module.exports = __webpack_public_path__ + "static/media/plus18.257c9fb3.svg";